import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isTokenValid } from '../api';
import { loginUrl } from '../lib/redirect';
import { isProviderRole } from '../lib/roles';

// Gate for the provider (hizmat ko'rsatuvchi) area: must be logged in as a
// provider with a still-valid token, otherwise back to login.
export default function ProviderRoute({ children }) {
  const { auth } = useAuth();
  const location = useLocation();
  if (!auth || !isProviderRole(auth.role)) {
    return <Navigate to={loginUrl(location)} replace />;
  }
  if (!isTokenValid(auth.token)) {
    return <Navigate to={loginUrl(location, 'expired=1')} replace />;
  }
  return children;
}
